import { observer } from 'mobx-react-lite'
import { Menu } from '../components/Menu'
import { MenuItem } from '../components/MenuItem'
import { useStore } from '../stores'

export const TreeMenu = observer(function TreeMenu({ onAction, tree }) {
    const { app } = useStore()

    const _onAction = action => {
        onAction && onAction(action)
    }

    return (
        <Menu>
            <MenuItem onClick={() => _onAction('focus_root')}>
                {app.text('Focus on root')}
            </MenuItem>
            <MenuItem onClick={() => _onAction('focus_selected')}>
                {app.text('Focus on selected')}
            </MenuItem>
        </Menu>
    )
})
